import { memo } from 'react'

function LogoSvg ({ innerFill = '#fff', outerFill = '#f73f21' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
      <g>
        <g>
          <rect style={{ fill: outerFill }} width="88" height="88" rx="12" />
          <path
            style={{ fill: innerFill }}
            d="M66.45,72.39H23V14.13a1.47,1.47,0,1,0-2.94,0V73.86a1.47,1.47,0,0,0,1.47,1.47h44.9a1.47,1.47,0,0,0,0-2.94Z"
          />
          <path
            style={{ fill: innerFill }}
            d="M63.55,62.22H31.47V18a1.31,1.31,0,1,0-2.61,0V63.53a1.31,1.31,0,0,0,1.31,1.31H63.55a1.31,1.31,0,0,0,0-2.62Z"
          />
          <circle
            style={{ fill: innerFill }}
            cx="52.6"
            cy="40.75"
            r="8.67"
          />
        </g>
      </g>
    </svg>
  )
}

export default memo(LogoSvg)
